import {
    fetchGetSharedFunctionality,
    GET_SHARED_FUNCTIONALITY_KEY,
    GetSharedFunctionalityResponse
} from '@iwoca/lapi-client/iwocapay';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

type TFunctionalities = keyof GetSharedFunctionalityResponse['data'];
export const useIwocaPayFunctionality = ({
    functionalities
}: {
    functionalities?: TFunctionalities[];
} = {}) => {
    const stateKey = useStateKey();
    const { data, error, isLoading } = useQuery({
        queryKey: [GET_SHARED_FUNCTIONALITY_KEY, stateKey, functionalities],
        queryFn: () =>
            fetchGetSharedFunctionality({
                stateKey,
                query: {
                    functionalities: functionalities
                }
            })
    });

    return {
        functionalities: data?.data || {},
        isLoading,
        error: error
    };
};
